const getSettingInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    name: data?.name || "",
    value: data?.value || "",
    description: data?.description || "",
  }
};

export default getSettingInitialValues;
